module.exports = __webpack_public_path__ + "media/packs/images/state/small/news-f3a1ae701098e59be6a29ae68a7de416.svg";